var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isPrefAvailable)?_c('div',{staticClass:"mylocal-tooltip"},[_vm._v("\n  Localise your news settings here\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }